import Store from 'store/store';
import pendingPromise from 'utils/pendingPromise';
import { geoFromIP, geoSearchOne } from 'utils/bolt/geo';

export { geoFromIP };

let currentLocationRequest = 0;
export async function setUserLocation(location, options) {
	let geo = Store.get().client.geo;
	let promise = geo.loading;
	if (!promise) {
		promise = pendingPromise();
		geo.set({ loading: promise }).now();
	}
	let requestId = ++currentLocationRequest;
	try {
		location = await (typeof location === 'function' ? location() : location);
	} catch (e) {
		console.log('Error while getting location', e);
	}

	if (requestId !== currentLocationRequest) {
		return;
	}
	let storeGeo = Store.get().client.geo.set({ loading: null });
	if (!location || !location.lat || !location.lon) {
		return promise.resolve();
	}
	let newValue = { ...location };
	// Legacy support
	if (!newValue.countryCode && newValue.country) {
		newValue.countryCode = newValue.country;
		delete newValue.country;
	}
	storeGeo.reset(newValue).now();
	promise.resolve(newValue);
	if (options?.source !== 'landing') {
		Store.emit('USER_LOCATION_UPDATED', { geo: newValue, source: options?.source });
	}
	return newValue;
}

export async function setLandingLocation() {
	let landingGeo = geoFromIP;

	const { lat, lon, country, location: qsLocation } = new URLSearchParams(location.search);

	if (+lat && +lon) {
		let usedCountry = country;
		if (!country) usedCountry = __REGION__.replace(/^([a-z]{2})_.+$/i, '$1');
		landingGeo = { lat: +lat, lon: +lon, city: qsLocation, country: usedCountry };
	} else if (qsLocation && typeof qsLocation === 'string') {
		landingGeo = () => geoSearchOne({ search: qsLocation });
	}

	// Store.emit('SET_USER_LOCATION', landingGeo, 'landing');
	const resolvedGeo = await setUserLocation(landingGeo, { source: 'landing' });
	Store.emit('GEOLOCATION', resolvedGeo);
}
